import { render, staticRenderFns } from "./Ubicacion.vue?vue&type=template&id=b0ab592c&scoped=true&"
var script = {}
import style0 from "./Ubicacion.vue?vue&type=style&index=0&id=b0ab592c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ab592c",
  null
  
)

export default component.exports